<template lang="html">
  <div>
     <vs-row id="center" >
             <p>Please choose which Tasks you would like to bulk complete</p>
            <vs-spacer />
            <vs-button
              color="success"
              type="flat"
              icon="done"
              @click="selectall()"
              >Select All </vs-button
            >
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="clearall()"
              >Clear All </vs-button
            > 
         </vs-row>
    
      <vs-table
        multiple
        search
        v-model="selected"
        :data="data">
        <template slot="header">
          <h5 class="ml-2">
            Work Order
          </h5>
        </template>
        <template slot="thead">
          <vs-th>
            Work ID
          </vs-th>
          <vs-th>
            Name
          </vs-th>
          <vs-th>
            Work Order
          </vs-th>
          <vs-th>
            Start Date
          </vs-th>
          <vs-th>
            End Date
          </vs-th>
          <vs-th>
            Status
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="data[indextr].id">
              {{data[indextr].id}}
            </vs-td>

            <vs-td :data="data[indextr].name">
              {{data[indextr].name}}
            </vs-td>

            <vs-td :data="data[indextr].detail">
              {{data[indextr].detail}}
            </vs-td>
            <vs-td :data="data[indextr].plandate">
              {{data[indextr].plandate}}
            </vs-td>
            <vs-td :data="data[indextr].duedate">
              {{data[indextr].duedate}}
            </vs-td>
            <vs-td :data="data[indextr].iscomplete">
              {{data[indextr].iscomplete}}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    <pre>{{ selected }}</pre>
  </div>
</template>

<script>
export default {
   props: ['data'],
  data:()=>({
    selected:[],
    users:[
      {
        "id": 1,
        "name": "Leanne Graham",
        "username": "Bret",
        "email": "Sincere@april.biz",
        "website": "hildegard.org",
      },
      {
        "id": 2,
        "name": "Ervin Howell",
        "username": "Antonette",
        "email": "Shanna@melissa.tv",
        "website": "anastasia.net",
      },
      {
        "id": 3,
        "name": "Clementine Bauch",
        "username": "Samantha",
        "email": "Nathan@yesenia.net",
        "website": "ramiro.info",
      },
      {
        "id": 4,
        "name": "Patricia Lebsack",
        "username": "Karianne",
        "email": "Julianne.OConner@kory.org",
        "website": "kale.biz",
      },
      {
        "id": 5,
        "name": "Chelsey Dietrich",
        "username": "Kamren",
        "email": "Lucio_Hettinger@annie.ca",
        "website": "demarco.info",
      },
      {
        "id": 6,
        "name": "Mrs. Dennis Schulist",
        "username": "Leopoldo_Corkery",
        "email": "Karley_Dach@jasper.info",
        "website": "ola.org",
      },
      {
        "id": 7,
        "name": "Kurtis Weissnat",
        "username": "Elwyn.Skiles",
        "email": "Telly.Hoeger@billy.biz",
        "website": "elvis.io",
      },
      {
        "id": 8,
        "name": "Nicholas Runolfsdottir V",
        "username": "Maxime_Nienow",
        "email": "Sherwood@rosamond.me",
        "website": "jacynthe.com",
      },
      {
        "id": 9,
        "name": "Glenna Reichert",
        "username": "Delphine",
        "email": "Chaim_McDermott@dana.io",
        "website": "conrad.com",
      },
      {
        "id": 10,
        "name": "Clementina DuBuque",
        "username": "Moriah.Stanton",
        "email": "Rey.Padberg@karina.biz",
        "website": "ambrose.net",
      }
    ]
  })
}
</script>
<style scoped>
#center{
  display: flex;
  align-items: center;
}
</style>